import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DataTable,
  Page,
  Filters,
  Image,
  ChoiceList,
  Loading,
  Card,
  Text,
  Banner,
  Spinner,
  ButtonGroup,
  Button,
  Modal,
  Badge,
  Toast,
  TextContainer,
  Link,
  Icon,
  FormLayout,
  Tooltip,
  Select,
  Layout,
  Thumbnail,
  InlineGrid,
  Box,
  BlockStack,
  Pagination,
  InlineStack,
  Divider,
  Tag,
  TextField,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import emptyListImage from "../../Assets/Images/emptyList.svg";
// import Pagination from "@material-ui/lab/Pagination";
import { useNavigate } from "react-router-dom";
import {
  ArrowUpIcon,
  ArrowDownIcon,
  LinkIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  EditIcon,
  PlusCircleIcon,
} from "@shopify/polaris-icons";
import EllipsisText from "react-ellipsis-text";
import lebanonIcon from "../../Assets/Images/lb.svg";
import iraqIcon from "../../Assets/Images/iq.svg";
import egyptIcon from "../../Assets/Images/eg.svg";

const Personas = (props) => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const refBoolPage = useRef(true);
  const refId = useRef(null);
  const [popupActive, setPopupActive] = useState(false);
  const perPage = 50;
  const [isLoading, setIsLoading] = useState(true);
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [items, setItems] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [sortState, setSortState] = useState("-id");
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const handleSort = () =>
    sortState === "id" ? setSortState("-id") : setSortState("id");
  const handleEdit = (id) => {
    navigate(`/admin/personas/${id}`);
  };
  const handleScreenshots = (id) => {
    // console.log("url=", `/admin/personas/${id}/screenshots`);
    navigate(`/admin/personas/${id}/screenshots`);
  };
  const handleAddItem = (id) => {
    navigate(`/admin/personas/new`);
  };

  const [ts, setTs] = useState("");
  const handleUp = (e) => {
    const bodyObj = {
      direction: "up",
    };
    axios
      .post(`/products/${e.currentTarget.id}/sort`, bodyObj)
      .then((res) => {
        fetchData();
      })
      .catch((err) => console.log(""));
  };
  const handleDown = (e) => {
    const bodyObj = {
      direction: "down",
    };
    axios
      .post(`/products/${e.currentTarget.id}/sort`, bodyObj)
      .then((res) => {
        fetchData();
      })
      .catch((err) => console.log(""));
  };
  const [optionsCategories, setOptionsCategories] = useState([
    { label: "All", value: "all" },
  ]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [countryFilter, setCountryFilter] = useState("All");
  const [tagFilter, setTagFilter] = useState("All");
  const [optionsTags, setOptionsTags] = useState([]);
  const [search, setSearch] = useState("");
  const [country, setCountry] = useState("");
  // const countryButtons = [
  //   { label: "All", value: "All" },
  //   { label: "Lebanon", value: "Lebanon", icon: lebanonIcon },
  //   { label: "Egypt", value: "Egypt", icon: egyptIcon },
  //   { label: "Iraq", value: "Iraq", icon: iraqIcon },
  // ];

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await axios.get(`/person-tags`);
        const data = response?.data?.data?.data;

        const options = [
          { label: "All", value: "All" },
          ...data.map((dept) => ({
            label: dept.text,
            value: dept.id,
          })),
        ];

        setOptionsTags(options);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };

    fetchTags();
  }, []);

  useEffect(() => {
    fetchData();
  }, [
    page,
    sortState,
    availability,
    queryValue,
    ts,
    countryFilter,
    search,
    country,
    tagFilter,
  ]);

  const [result, setResult] = useState(null);
  async function fetchData() {
    let response = "";

    try {
      const params = new URLSearchParams();
      if (search) params.append("filter[title]", search);
      // if (countryFilter !== "All")
      //   params.append("filter[country]", countryFilter);
      country !== "" && params.append("filter[country]", country);
      tagFilter !== "All" && params.append("filter[tags.id]", tagFilter);
      response = await axios.get(`/personas`, { params });
      setResult(response.data.data.data);
      !response.data.data.data.length
        ? setIsListEmpty(true)
        : setIsListEmpty(false);
      setTotalPages(response.data.data.total);
      setItems(
        response.data.data.data.map((item, index) => [
          // <div className="row_click2">
          //   {item?.image ? <Thumbnail size="small" source={item?.image} /> : ""}
          // </div>,
          <div className="row_click2">
            {item?.image_url ? (
              <Thumbnail size="extraSmall" source={item.image_url}></Thumbnail>
            ) : (
              "-"
            )}
          </div>,

          <div className="row_click2">{item?.title || "-"}</div>,
          <div className="row_click2">{item?.age_range || "-"}</div>,

          <div className="me-3">
            <ButtonGroup>
              <Button onClick={() => handleEdit(item.id)}>Edit</Button>
            </ButtonGroup>
          </div>,
        ])
      );
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    // {
    //   key: "availability",
    //   label: "Filter by",
    //   filter: (
    //     <ChoiceList
    //       title="Filter by"
    //       titleHidden
    //       choices={[{ label: "Title", value: "title" }]}
    //       selected={availability || []}
    //       onChange={handleAvailabilityChange}
    //     />
    //   ),
    //   shortcut: true,
    // },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }

  const loadingMarkup = isLoading ? <Loading /> : null;
  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage}></img>
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This page has been successfully Showd"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [activeShow, setActiveShow] = useState(false);

  const handleChangeModalShow = useCallback((activeShow) => {
    setActiveShow(!activeShow);
  }, []);
  const handleShow = (id) => {
    refId.current = id;
    setActiveShow(true);
  };

  const handleYesShow = () => {
    setIsSaving(true);
    axios
      .Show(`brands/${refId.current}`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveShow(!activeShow);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const sliderRef = useRef(null);

  const scroll = (direction) => {
    if (sliderRef.current) {
      const scrollAmount = 300; // width of a column + gap
      sliderRef.current.scrollBy({
        left: direction === "next" ? scrollAmount : -scrollAmount,
        behavior: "smooth",
      });
    }
  };
  // Function to generate random pastel color
  const getRandomPastelColor = () => {
    const hue = Math.floor(Math.random() * 360);
    return `hsl(${hue}, 70%, 85%)`; // pastel HSL
  };
  const pastelColors = [
    "#FFD1DC", // pink
    "#C1E1C1", // green
    "#AEC6CF", // blue
    "#FFFACD", // yellow
    "#FFDAB9", // peach
    "#E6E6FA", // lavender
    "#F0E68C", // khaki
  ];
  const refClicked = useRef("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const handleNext = () => {
    if (currentIndex < result.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  const [countryButtons, setCountryButtons] = useState([]);
  useEffect(() => {
    axios
      .get("/settings/countries")
      .then((res) => {
        const countriesData = res?.data?.data || [];
        const options = [
          { label: "All", value: "" },
          { label: "Mutual", value: "All" },
          ...countriesData.map((country) => ({
            label: country.name,
            value: country.name,
            flag: country.flag,
          })),
        ];
        setCountryButtons(options);
        // setCountry(options?.[0]);
      })
      .catch((err) => console.log(err));
  }, []);
  return result ? (
    <Page
      title="Personas"
      primaryAction={
        <Button variant="primary" onClick={handleAddItem} icon={PlusCircleIcon}>
          Add Persona
        </Button>
      }
      // secondaryActions={
      //   <ButtonGroup>
      //     <Button onClick={() => navigate("/admin/personas/edit/tags")}>
      //       Tags
      //     </Button>
      //   </ButtonGroup>
      // }
      fullWidth
    >
      <FormLayout>
        {/* <Card>
          <BlockStack gap="500">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexWrap: "wrap",
                gap: "1rem",
              }}
            >
              <InlineStack gap="300" wrap>
                <ButtonGroup segmented>
                  {countryButtons.map((t) => (
                    <Button
                      key={t.value}
                      pressed={country === t.value}
                      onClick={() => setCountry(String(t.value))}
                    >
                      {t.flag && (
                        <img
                          src={t.flag}
                          alt={t.label}
                          style={{ width: 20, marginRight: 6 }}
                        />
                      )}
                      {t.label}
                    </Button>
                  ))}
                </ButtonGroup>
              </InlineStack>
              <Select
                label="Tag: "
                value={tagFilter}
                onChange={setTagFilter}
                options={optionsTags}
                labelInline
              />
            </div>
          </BlockStack>
        </Card> */}

        <Card>
          <BlockStack gap="500">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center", // 👈 vertically center both sides
                flexWrap: "wrap",
                gap: "1rem",
              }}
            >
              {/* 🔹 Left side: Filter */}
              <InlineStack gap="300" wrap align="center">
                <Select
                  label="Tag"
                  value={tagFilter}
                  onChange={setTagFilter}
                  options={optionsTags}
                />
              </InlineStack>

              {/* 🔹 Right side: ButtonGroup */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center", // 👈 centers vertically
                }}
              >
                <ButtonGroup segmented>
                  {countryButtons.map((t) => (
                    <Button
                      key={t.value}
                      pressed={country === t.value}
                      onClick={() => setCountry(String(t.value))}
                    >
                      {t.flag && (
                        <img
                          src={t.flag}
                          alt={t.flag}
                          style={{ width: 20, marginRight: 6 }}
                        />
                      )}
                      {t.label}
                    </Button>
                  ))}
                </ButtonGroup>
              </div>
            </div>
          </BlockStack>
        </Card>

        {result?.length ? (
          <>
            {/* Cards Grid (Polaris InlineGrid) */}
            <InlineGrid
              columns={{ xs: 1, sm: 2, md: 3, lg: 5 }}
              gap="500"
              alignItems="start"
              style={{ padding: "16px 32px" }}
            >
              {result?.map((persona, index) => (
                <Box
                  key={persona.id}
                  onClick={() => {
                    setCurrentIndex(index);
                    setActiveShow(true);
                  }}
                  // background="bg-surface"
                  borderRadius="300"
                  shadow="100"
                  style={{
                    cursor: "pointer",
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    position: "relative",
                    overflow: "hidden",
                    height: "100%",
                    backgroundColor: "white",
                    borderRadius: "8px",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.03)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 2px 6px rgba(0,0,0,0.1)";
                  }}
                >
                  {/* 🖊️ Edit Icon */}
                  <div
                    style={{
                      position: "absolute",
                      top: "8px",
                      right: "8px",
                      zIndex: 2,
                      background: "rgba(255,255,255,0.85)",
                      borderRadius: "8px",
                      padding: "4px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/admin/personas/${persona.id}`);
                    }}
                  >
                    <Icon source={EditIcon} color="base" />
                  </div>

                  {/* 🖼️ Image with Title Overlay */}
                  <div
                    style={{
                      position: "relative",
                      height: "180px",
                      borderRadius: "12px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={persona.image_url}
                      alt={persona.title}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        padding: "6px",
                        background: "rgba(255,255,255,0.85)",
                        textAlign: "center",
                      }}
                    >
                      <Text fontWeight="semibold" as="p" truncate>
                        {persona.title}
                      </Text>
                    </div>
                  </div>

                  {/* 📜 Card Content */}
                  <div
                    style={{
                      padding: "10px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                    }}
                  >
                    <Text as="p" size="small" tone="subdued">
                      <b>Age:</b> <Tag>{persona.age_range ?? "-"}</Tag>
                    </Text>

                    {persona.lifestyle && (
                      <Text as="p" size="small" tone="subdued">
                        <b>Lifestyle:</b>{" "}
                        {persona.lifestyle.length > 150
                          ? persona.lifestyle.slice(0, 150) + "..."
                          : persona.lifestyle || "-"}
                      </Text>
                    )}
                  </div>
                </Box>
              ))}
            </InlineGrid>

            {/* <Filters
            queryValue={queryValue}
            filters={filters}
            appliedFilters={appliedFilters}
            onQueryChange={handleFiltersQueryChange}
            onQueryClear={handleQueryValueRemove}
            onClearAll={handleFiltersClearAll}
          /> */}

            {/* <DataTable
            columnContentTypes={["text", "text", "text", "text"]}
            headings={[
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Image
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Title
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Age Range
              </Text>,

              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
            ]}
            rows={items}
            sortable={[false, false, false, false]}
            defaultSortDirection="descending"
            initialSortColumnIndex={0}
            onSort={handleSort}
            verticalAlign="middle"
            stickyHeader
            // hasZebraStripingOnData
            footerContent={
              items?.length &&
              `Showing ${items.length} of ${totalPages} results`
            }
            increasedTableDensity
          />

          {emtyState} */}
          </>
        ) : (
          <Card>
            <div
              style={{
                display: "flex",
                justifyContent: "middle",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div style={{ width: "25%" }}>
                <img src={emptyListImage}></img>
              </div>
              <div className="mb-3">
                <Text variant="headingLg" as="h5" color="subdued">
                  No results found
                </Text>
              </div>
              <br />
            </div>
          </Card>
        )}

        {/* {Math.ceil(totalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              count={Math.ceil(totalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            />
          </div>
        )} */}
      </FormLayout>
      <Modal
        open={activeShow}
        onClose={handleChangeModalShow}
        title={result?.[currentIndex]?.title}
        primaryAction={{
          content: "Next",
          onAction: handleNext,
          disabled: currentIndex === result?.length - 1,
        }}
        secondaryActions={[
          {
            content: "Previous",
            onAction: handlePrevious,
            disabled: currentIndex === 0,
          },
        ]}
      >
        <Modal.Section>
          <InlineGrid columns={{ xs: "1fr", sm: "0.8fr 1.5fr" }} gap="500">
            {/* LEFT SIDE */}
            <BlockStack gap="200" align="start">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  justifyContent: "flex-start", // ✅ ensure top alignment
                }}
              >
                {/* <Thumbnail
                  size="large"
                  source={result?.[currentIndex]?.image_url}
                  alt={result?.[currentIndex]?.title}
                /> */}
                <img
                  style={{
                    width: "200px", // fixed width
                    height: "200px", // fixed height (same as width)
                    objectFit: "cover", // ensures image fits nicely without distortion
                    borderRadius: "10px", // rounded corners
                  }}
                  src={result?.[currentIndex]?.image_url}
                ></img>

                {result?.[currentIndex]?.age_range && (
                  <div style={{ marginTop: "6px" }}>
                    <Tag>{result?.[currentIndex]?.age_range}</Tag>
                  </div>
                )}
              </div>
            </BlockStack>

            {/* RIGHT SIDE */}
            <BlockStack gap="300">
              {result?.[currentIndex]?.lifestyle && (
                <>
                  <Text as="p" fontWeight="semibold">
                    Lifestyle
                  </Text>
                  <Text>{result?.[currentIndex]?.lifestyle}</Text>
                  <Divider borderColor="border" />
                </>
              )}

              {result?.[currentIndex]?.shopping_habits && (
                <>
                  <Text as="p" fontWeight="semibold">
                    Shopping Habits
                  </Text>
                  <Text>{result?.[currentIndex]?.shopping_habits}</Text>
                  <Divider borderColor="border" />
                </>
              )}

              {result?.[currentIndex]?.attitude && (
                <>
                  <Text as="p" fontWeight="semibold">
                    Attitude
                  </Text>
                  <Text>{result?.[currentIndex]?.attitude}</Text>
                  <Divider borderColor="border" />
                </>
              )}

              {result?.[currentIndex]?.triggers && (
                <>
                  <Text as="p" fontWeight="semibold">
                    Triggers
                  </Text>
                  <Text>{result?.[currentIndex]?.triggers}</Text>
                  <Divider borderColor="border" />
                </>
              )}

              {result?.[currentIndex]?.challenges && (
                <>
                  <Text as="p" fontWeight="semibold">
                    Challenges
                  </Text>
                  <Text>{result?.[currentIndex]?.challenges}</Text>
                  <Divider borderColor="border" />
                </>
              )}

              {result?.[currentIndex]?.how_she_speaks && (
                <>
                  <Text as="p" fontWeight="semibold">
                    How she speaks
                  </Text>
                  <Text>{result?.[currentIndex]?.how_she_speaks}</Text>
                </>
              )}
            </BlockStack>
          </InlineGrid>
        </Modal.Section>
      </Modal>

      {toastMarkup}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );

  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }

  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function findElementByID(array, id) {
    return array.find((element) => {
      return element.id === id;
    });
  }
};

export default Personas;
